import type { JSX } from "react";

import { swSettings } from "app/common/services/swSettings";
import { RestrictedOptionListItem } from "app/components/SharingModal/components/RestrictedOptionListItem/RestrictedOptionListItem";
import type { IUserInfoExtended } from "app/components/SharingModal/types";
import { getMyUserInfo } from "app/components/SharingModal/utils";

import { Container } from "./RestrictedOptionList.styled";

interface IRestrictedOptionListProps<T> {
    selectedUsersIDs: Array<number>;
    onRemoveUser: (user: T) => void;
    users: T[];
}

export const RestrictedOptionList = <T extends IUserInfoExtended>({
    selectedUsersIDs,
    onRemoveUser,
    users,
}: IRestrictedOptionListProps<T>): JSX.Element => {
    const {
        user: { id, firstname: firstName, lastname: lastName, username: email },
    } = swSettings;

    const myUser = getMyUserInfo(id, email, firstName, lastName);

    const selectedUsers = [myUser as T, ...users.filter(({ id }) => selectedUsersIDs.includes(id))];

    return (
        <Container>
            {selectedUsers.map((user) => {
                const handleRemoveUser = (): void => {
                    onRemoveUser(user);
                };

                return (
                    <RestrictedOptionListItem
                        key={user.id}
                        onRemoveUser={handleRemoveUser}
                        name={user.text}
                        email={user.email}
                        isMyUser={user.isMyUser}
                    />
                );
            })}
        </Container>
    );
};
